import { ActionIcon, Modal } from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";
import { Task } from "beitary-shared";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TaskForm } from "../TaskForm";

export interface EditTaskModalProps {
  task: Task;
}

export const EditTaskModal = ({ task }: EditTaskModalProps) => {
  const { t } = useTranslation();

  const [opened, setOpened] = useState(false);

  return (
    <>
      <Modal
        size="xl"
        opened={opened}
        onClose={() => setOpened(false)}
        title={t("EDIT_TASK")}
        closeOnClickOutside={false}
        overlayProps={{
          color: "white",
          opacity: 0.55,
          blur: 3,
        }}
      >
        <div>
          <TaskForm task={task} />
        </div>
      </Modal>
      <ActionIcon onClick={() => setOpened(true)}>
        <IconEdit size={18} />
      </ActionIcon>
    </>
  );
};
